import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportHistoryCheckParameter } from '@api/hitoryCheck';

import { THistoryCheckExportParameterDTO } from '@interfaces/cmModule/dto/historyCheckDTO';

import { ESnackbarTypes } from '@enums/common';

import { HC_BRANCH_PARAMETERS_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateExportHcParametersReturnType {
	exportParameters: UseMutateFunction<any, any, THistoryCheckExportParameterDTO, any>;
}

export const useMutateExportHcParameters = (): IUseMutateExportHcParametersReturnType => {
	const dispatch = useAppDispatch();

	const { mutate } = useMutation<THistoryCheckExportParameterDTO>({
		mutationKey: [HC_BRANCH_PARAMETERS_EXPORT],
		mutationFn: exportHistoryCheckParameter,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportConfigurationComparisonSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return { exportParameters: mutate };
};
